import angular from 'angular';

export default angular.module('cms.filter.file-size', [])
    .filter('fileSize', function () {
        return function (bytes, precision) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
            if (typeof precision === 'undefined') precision = 1;
            let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'],
                number = Math.floor(Math.log(bytes) / Math.log(1000));
            return (bytes / Math.pow(1000, number)).toFixed(precision) + ' ' + units[number];
        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/FileSizeFilter/FileSizeFilter.js